module.exports = __webpack_public_path__ + "img/item_part_display.55fcc7e5.png";